var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { FACILITY_BREADCRUMB_OPTIONS, Roles } from 'globals/enums';
import { facilitySlugs } from 'globals/global.constants';
import { getFacilityData } from 'pages/WCPages/Admin/CorporateAndFacilities/FacilityManagement/FacilityManagement.action';
import React from 'react';
import { useParams } from 'react-router-dom';
import { getFacilityListService } from 'services/addResidentServices/facilityList/facility.service';
import { getSeniorFullName, setSeniorDetail, } from 'store/commonReducer/common.action';
import { useAppDispatch, useAppSelector } from './reduxHooks';
import useGenerateBreadcrumbData from './useGenerateBreadcrumbData';
var promiseResolve = function (value) { return Promise.resolve(value); };
/**
 * @description hook to access the breadcrumb options and store API logic.
 * @returns {IUseFacitlityBreadcrumbReturn}
 */
var useFacitlityBreadcrumb = function () {
    var breadcrumbOptionsArray = Object.values(FACILITY_BREADCRUMB_OPTIONS);
    var urlParams = useParams();
    var dispatch = useAppDispatch();
    var minimalInfo = useAppSelector(function (state) { return state.common.seniorDetail.minimalInfo; });
    var currentUserRoles = useAppSelector(function (state) { return state.auth.userRole; });
    var fullname = React.useMemo(function () { return dispatch(getSeniorFullName()); }, [dispatch, minimalInfo]);
    var seniorId = urlParams[facilitySlugs.residentDashboard];
    var accountId = urlParams[facilitySlugs.accountID];
    var isResidentDetailCurrent = !seniorId ||
        (minimalInfo.user_id === seniorId && minimalInfo.account_id === accountId);
    var queryOptions = React.useMemo(function () {
        var _a;
        return (_a = {},
            _a[FACILITY_BREADCRUMB_OPTIONS.FACILITY_MANAGEMENT] = {
                fetchAsync: function () { return promiseResolve('Agency Management'); },
                dataModifier: function (data) { return ({ data: data, path: '' }); },
                slug: facilitySlugs.accountID,
                disable: false,
                roles: [Roles.Admin, Roles.BDM, Roles.Admin_WellnessServices],
            },
            _a[FACILITY_BREADCRUMB_OPTIONS.FACILITY_HOME] = {
                fetchAsync: function () { return __awaiter(void 0, void 0, void 0, function () {
                    var apiParams;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                apiParams = {
                                    facility_ids: JSON.stringify([
                                        urlParams[facilitySlugs.facilityHomePage],
                                    ]),
                                };
                                return [4 /*yield*/, getFacilityListService(apiParams)];
                            case 1: return [2 /*return*/, _a.sent()];
                        }
                    });
                }); },
                dataModifier: function (data) {
                    var _a, _b;
                    return ({
                        data: (_a = data === null || data === void 0 ? void 0 : data.data[0]) === null || _a === void 0 ? void 0 : _a.name,
                        path: "".concat(facilitySlugs.facilityManagement, "/").concat(urlParams[facilitySlugs.facilityHomePage]),
                        dependentPath: {
                            key: FACILITY_BREADCRUMB_OPTIONS.FACILITY_MANAGEMENT,
                            path: "portal-admin/corporate-agencies/".concat((_b = data === null || data === void 0 ? void 0 : data.data[0]) === null || _b === void 0 ? void 0 : _b.corporateId),
                        },
                    });
                },
                slug: facilitySlugs.accountID,
                roles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.BDM, Roles.Admin_WellnessServices],
                onSuccess: function (data) {
                    dispatch(getFacilityData(data.data[0]));
                },
                disable: currentUserRoles.includes(Roles.BDM),
            },
            _a[FACILITY_BREADCRUMB_OPTIONS.FACILITY_DASHBOARD] = {
                fetchAsync: function () { return promiseResolve('Dashboard'); },
                dataModifier: function (data) { return ({ data: data, path: '' }); },
                slug: facilitySlugs.facilityDashboard,
                roles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.BDM, Roles.Admin_WellnessServices],
                disable: false,
            },
            _a[FACILITY_BREADCRUMB_OPTIONS.FACILITY_RESIDENTS] = {
                fetchAsync: function () { return promiseResolve('Clients'); },
                dataModifier: function (data) { return ({
                    data: data === null || data === void 0 ? void 0 : data.trim(),
                    path: "".concat(urlParams[facilitySlugs.facilityResident]),
                }); },
                slug: facilitySlugs.facilityResident,
                disable: false,
                roles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
            },
            _a[FACILITY_BREADCRUMB_OPTIONS.RESIDENT_DASHBOARD] = {
                fetchAsync: function () { return promiseResolve(''); },
                dataModifier: function (data) {
                    return {
                        data: data,
                        path: "".concat(urlParams[facilitySlugs.residentDashboard], "/").concat(urlParams[facilitySlugs.accountID], "/").concat(urlParams[facilitySlugs.timezone] || ''),
                    };
                },
                slug: facilitySlugs.accountID,
                disable: false,
                roles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
            },
            _a[FACILITY_BREADCRUMB_OPTIONS.FACILITY_LOCATION] = {
                fetchAsync: function () { return promiseResolve('Location'); },
                dataModifier: function (data) { return ({ data: data, path: '' }); },
                slug: '',
                disable: false,
                roles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
            },
            _a[FACILITY_BREADCRUMB_OPTIONS.FACILITY_WELLNESS_DATA] = {
                fetchAsync: function () { return promiseResolve('Wellness Data'); },
                dataModifier: function (data) { return ({ data: data, path: '' }); },
                slug: '',
                disable: false,
                roles: [Roles.Admin, Roles.FACILITY_AGENT, Roles.Admin_WellnessServices],
            },
            _a);
    }, [dispatch, urlParams]);
    var breadcrumbData = useGenerateBreadcrumbData(queryOptions, breadcrumbOptionsArray, currentUserRoles);
    if (breadcrumbData[FACILITY_BREADCRUMB_OPTIONS.RESIDENT_DASHBOARD]) {
        breadcrumbData[FACILITY_BREADCRUMB_OPTIONS.RESIDENT_DASHBOARD] = __assign(__assign({}, breadcrumbData[FACILITY_BREADCRUMB_OPTIONS.RESIDENT_DASHBOARD]), { isLoading: !isResidentDetailCurrent || !fullname.trim(), value: isResidentDetailCurrent ? fullname.trim() : '' });
    }
    React.useEffect(function () {
        if (urlParams[facilitySlugs.residentDashboard] &&
            urlParams[facilitySlugs.accountID] &&
            (minimalInfo.user_id !== urlParams[facilitySlugs.residentDashboard] ||
                minimalInfo.account_id !== urlParams[facilitySlugs.accountID])) {
            dispatch(setSeniorDetail());
        }
    }, [accountId, dispatch, minimalInfo.account_id, minimalInfo.user_id, seniorId]);
    return {
        options: breadcrumbData,
    };
};
export default useFacitlityBreadcrumb;
